import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_e9d2d82fb981ca778fa8ad9752b51362/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}